import classes from './DateSummary.module.css'
import React from 'react'

const DateSummary = (props) => {
  //weekDay
  //fullDate

  return (
    <div className={classes.dateContainer}>
      <div
        className={`${classes.CheckInDateContainer} ${classes.calendarIcon}`}
      >
        <p className={classes.weekDay}>Check In: {props.checkInWeekday}</p>
        <p className={classes.fullDay}>{props.checkInDate}</p>
      </div>
      <div
        className={`${classes.CheckOutDateContainer} ${classes.calendarIcon}`}
      >
        <p className={classes.weekDay}>Check Out: {props.checkOutWeekday}</p>
        <p className={classes.fullDay}>{props.checkOutDate}</p>
      </div>
    </div>
  )
}

export default DateSummary
